document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct()
    
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});
$(document).ready(function(){
    customProduct();
})

function customProduct() {
    $('.product').each(function() {
        var sku = $(this).find('span[data-micro="sku"]').text();
        var basicLink = $(this).find('a.image').attr('href')
        if ($(this).find('.price-standard').length) {
            $(this).find('.prices').prepend($(this).find('.price-standard'));
        }
        if($(this).find('.p-desc').length){ 
            $(this).find('a.name').after($(this).find('.p-desc'))
        }
        else{
            $(this).find('a.name').after('<p class="p-desc" data-micro="description" data-testid="productCardShortDescr"></p>')
        }

    });
}